var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 74,
    height: 85,
    viewBox: "0 0 74 85",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32 79.8418C32 82.6032 34.2386 84.8418 37 84.8418C39.7614 84.8418 42 82.6032 42 79.8418L32 79.8418ZM40.5356 2.28005C38.583 0.327431 35.4171 0.327423 33.4645 2.28004L1.64469 34.0998C-0.307933 36.0525 -0.307937 39.2183 1.64468 41.1709C3.5973 43.1235 6.76313 43.1235 8.71575 41.1709L37 12.8867L65.2843 41.1709C67.2369 43.1236 70.4027 43.1236 72.3554 41.1709C74.308 39.2183 74.308 36.0525 72.3554 34.0999L40.5356 2.28005ZM37 79.8418L42 79.8418L42 5.81558L37 5.81558L32 5.81558L32 79.8418L37 79.8418Z",
    fill: "#D7DBE2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowUp);
export default __webpack_public_path__ + "static/media/arrow-up.34ff4cc3964c88bf7518f6fe4f39f502.svg";
export { ForwardRef as ReactComponent };